import React, { useEffect, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import icon from '../../icons/create/upload.svg'
import docxIcon from '../../icons/create/document.svg'
import { Modal, Select } from 'antd'
import { getCookie } from 'helper/cookie'
import { uploadHoliday, checkHoliday } from 'api/Admin/holiday'
import { checkImportAccount, importAccount } from 'api/MasterData/userManagement'
import {
  CheckCircleOutlined,
  DeleteOutlined,
  CloseCircleOutlined,
  PlusOutlined,
  WarningOutlined,
} from '@ant-design/icons'
import loadingIcons from 'icons/three-dots.svg'
// SuccessImport
import iconSuccess from 'icons/SuccessImport.png'

import { Button, Table, Input, Space, Row, Col, Form } from 'antd'
let datafiles = []

import lang from 'lang/en'
import _ from 'lodash'

const initalState = {
  data: [],
  isLoading: true,
  pagination: {
    pageSize: 10, //จำนวนข้อมูลในหน้านั้น
    total: 0, //ข้อมูลทั้งหมด
    current: 1,
    showSizeChanger: true,
    showTotal: (total, range) => showToalPagination(total, range),
  },
}

const showToalPagination = (total, range) => {
  return <p className="small-show-total">{`${range[0]}-${range[1]} of ${total}`}</p>
}

const Importfile = (props) => {
  const {
    visible,
    setVisible,
    parent_ID,
    getResultDataHolidayDetail,
    fetchListHolidayINcompany,
    state,
    dataTree
  } = props

  const [formHolidayDetail] = Form.useForm()
  const language = getCookie('lang')
  const word = lang[language]
  const [files2, setFiles2] = useState([])
  const [show, setShow] = useState(false)
  const [loading, setLoading] = useState(false)
  const [stateFile, setStateFile] = useState(false)
  const token = getCookie('access_token_admin')

  const [checkDataError, setCheckDataError] = useState(false)
  const [dataError, setDataError] = useState([])
  const [dataSuccess, setDataSuccess] = useState([])

  const [displayBtnUpload, setDisplayBtnUpload] = useState(false)
  const [wordBtnUpload, setWordBtnUpload] = useState(word['Import'])

  const [pagination, setPagination] = useState(initalState.pagination)

  const [visibleModalSuccess, setVisibleModalSuccess] = useState(false)
  const [visibleCantDelete, setVisibleCantDelete] = useState(false)
  const [checkClickRetry, setCheckClickRetry] = useState(false)

  const [listcompanysearch, setListCompanySearch] = useState([])
  const [listopersearch, setListOperSearch] = useState([])
  const [listsubsearch, setListSubSearch] = useState([])

  let titleModal = ''
  if (state == 'Holiday') {
    titleModal = word['Import_Holiday_detail']
  } else if (state == 'User') {
    titleModal = word['Import_User']
  }
  let listTypleFile = '.xlsx'

  useEffect(() => {
    if (visible === true) {
      if (checkClickRetry == true) {
        setFiles2([])
        datafiles = []
      } else {
        setFiles2([])
        datafiles = []
      }
      setCheckClickRetry(false)
      setShow(false)
      setLoading(false)
      setStateFile(false)
      setDisplayBtnUpload(false)
      setWordBtnUpload(word['Import'])
    }
  }, [visible])
  const documentUpload = async (dataForm) => {
    const FormValue = dataForm
    // console.log(FormValue)
    if (files2.length > 0) {
      if (state == 'Holiday') {
        if (wordBtnUpload == 'Upload') {
          for (let index = 0; index < files2.length; index++) {
            const data = new FormData()
            data.append('uploadfile', files2[index])
            // data.append('holiday_id', parent_ID)
            data.append('holiday_name', FormValue.holiday_name_th)
            data.append('holiday_name_en', FormValue.holiday_name_en)
            data.append('com_id', FormValue.company)
            if (FormValue.operation !== null && FormValue.operation !== undefined) {
              data.append('oper_id', FormValue.operation)
            }
            if (FormValue.sub_operation !== null && FormValue.sub_operation !== undefined) {
              data.append('suboper_id', FormValue.sub_operation)
            }
            // console.log(data.data)
            try {
              setLoading(true)
              await uploadHoliday({
                params: data,
                token: token,
              }).then((res) => {
                if (res.status === 200) {
                  formHolidayDetail.setFieldsValue({
                    holiday_name_th: null,
                    holiday_name_en: null,
                    operation: null,
                    sub_operation: null,
                  })
                  setListSubSearch([])
                  setVisibleModalSuccess(true)
                  setShow(false)
                  setVisible(false)
                  setStateFile(false)
                  setDisplayBtnUpload(false)
                  setWordBtnUpload(word['Import'])
                  getResultDataHolidayDetail()
                  fetchListHolidayINcompany(FormValue.company)
                }
              })
            } catch (error) {
              console.log(error)
            }
          }
          setLoading(false)
        } else {
          for (let index = 0; index < files2.length; index++) {
            const data = new FormData()
            data.append('uploadfile', files2[index])
            data.append('holiday_id', parent_ID)
            // console.log(data)
            try {
              setLoading(true)
              await checkHoliday({
                params: data,
                token: token,
              }).then((res) => {
                if (res.status === 200) {
                  // console.log(res)
                  let arr = []
                  res.data.map((item) => {
                    if (item.error) {
                      arr.push(item)
                    }
                  })
                  setDataError(arr)
                  files2[index].status = true
                  let checkerror = false
                  res.data.map((item) => {
                    if (item.error) {
                      checkerror = true
                    }
                  })

                  if (checkerror == true) {
                    setDisplayBtnUpload(true)
                    setCheckDataError(true)
                  } else {
                    setDataSuccess(res.data)
                    setDisplayBtnUpload(false)
                    setCheckDataError(false)
                  }
                } else {
                  setDisplayBtnUpload(true)
                  setCheckDataError('nopass')
                  files2[index].status = false
                }
              })
            } catch (error) {
              console.log(error)
            }
          }
          setLoading(false)
          setTimeout(() => {
            setWordBtnUpload(word['Upload'])
            setShow(false)
            setStateFile(true)
            // setDisplayBtnUpload(true)
          }, 500)

          setPagination((prevState) => {
            return {
              ...prevState,
              pageSize: 10,
              current: 1,
            }
          })
        }
      }
      else if (state == 'User') {
        if (wordBtnUpload == 'Upload') {
          for (let index = 0; index < files2.length; index++) {
            const data = new FormData()
            data.append('uploadfile', files2[index])
            try {
              setLoading(true)
              await importAccount({
                params: data,
                token: token,
              }).then((res) => {
                if (res.status === 200) {
                  setVisibleModalSuccess(true)
                  getResultDataHolidayDetail()
                  setShow(false)
                  setVisible(false)
                  setStateFile(false)
                  setDisplayBtnUpload(false)
                  setWordBtnUpload(word['Import'])
                }
              })
            } catch (error) {
              console.log(error)
            }
          }
          setLoading(false)
        } else {
          for (let index = 0; index < files2.length; index++) {
            const data = new FormData()
            data.append('uploadfile', files2[index])
            try {
              setLoading(true)
              await checkImportAccount({
                params: data,
                token: token,
              }).then((res) => {
                if (res.status === 200) {
                  if (res.data.status == 'fail') {
                    setDisplayBtnUpload(true)
                    setCheckDataError(true)

                    let arr = []

                    if (res.data.msg_error[0] == 'empty file') {
                      setDisplayBtnUpload(true)
                      setCheckDataError('nopass')
                      files2[index].status = false
                    } else {
                      for (let index = 1; index <= res.data.total; index++) {
                        res.data.msg_error[index] == undefined
                          ? _
                          : arr.push({
                            row_id: index,
                            message:
                              res.data.msg_error[index].charAt(0).toUpperCase() +
                              res.data.msg_error[index].slice(1),
                          })
                      }

                      setDataError(arr)
                    }
                  } else {
                    setDataSuccess(res.data.total)
                    setDisplayBtnUpload(false)
                    setCheckDataError(false)
                  }
                } else {
                  setDisplayBtnUpload(true)
                  setCheckDataError('nopass')
                  files2[index].status = false
                }
              })
            } catch (error) {
              console.log(error)
            }
          }
          setLoading(false)
          setTimeout(() => {
            setWordBtnUpload(word['Upload'])
            setShow(false)
            setStateFile(true)
            // setDisplayBtnUpload(true)
          }, 500)

          setPagination((prevState) => {
            return {
              ...prevState,
              pageSize: 10,
              current: 1,
            }
          })
        }
      }
    }
  }
  const showIcons = (status) => {
    if (show === true) {
      if (status === true) {
        return <CheckCircleOutlined className="checkcircleoutlined" />
      } else if (status === false) {
        return <CloseCircleOutlined className="CloseCircleOutlined " />
      } else {
        return <> </>
      }
    }
  }
  const onCancel = () => {
    if (wordBtnUpload != 'Import') {
      if (checkDataError == 'nopass' || checkDataError == true) {
        setVisibleCantDelete(true)
      } else {
        setFiles2([])
        datafiles = []
      }
    }

    setShow(false)
    setVisible(false)
    setStateFile(false)
    setDisplayBtnUpload(false)
    setWordBtnUpload(word['Import'])
    formHolidayDetail.resetFields(['operation', 'sub_operation', 'holiday_name_th', 'holiday_name_en'])
  }

  const { fileRejections, getRootProps, getInputProps } = useDropzone({
    multiple: false,
    accept: listTypleFile,
    onDrop: (acceptedFiles) => {
      setFiles2(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
            status,
          }),
        ),
      )
    },
  })

  const handleDelete = (path) => {
    setShow(false)
    const newFile = datafiles.filter((item) => item.path != path)
    datafiles = newFile
    setFiles2(datafiles)
  }

  const acceptedFileItems2 = (files23) => {
    return files23.map((file) => {
      return (
        <div className="doculist-container" key={file.path}>
          <img src={docxIcon}></img>
          <p>{file.path}</p>
          {showIcons(file.status)}
          <DeleteOutlined
            className="deleteoutlined"
            onClick={() => handleDelete(file.path)}
          />
        </div>
      )
    })
  }

  const onClickUploadFile = () => {
    setFiles2([])
    datafiles = []
    setShow(false)
    setStateFile(false)
    setDisplayBtnUpload(false)
    setWordBtnUpload(word['Import'])
  }

  useEffect(() => {

    if (dataTree?.length !== 0 && dataTree !== undefined) {
      const dataCompanySetup = dataTree.map((c) => {
        return {
          key: c.id,
          value: c.id,
          label: c.title,
        }

      })
      const findCompanyDefaultMatch = dataTree.find((f) => f.id === parent_ID)
      setListCompanySearch(dataCompanySetup)
      formHolidayDetail.setFieldsValue({
        company: findCompanyDefaultMatch?.id || null
      })
      onChangeEvent(findCompanyDefaultMatch?.id, 'company')
    }

  }, [parent_ID])

  const onChangeEvent = (e, type) => {
    // console.log(e, type)
    if (type === 'company') {

      const companyID = e
      const dataFindCompanyMatch = dataTree.find((c) => c.id === companyID)
      const operationList = dataFindCompanyMatch?.children
      const dataOperation = operationList?.map((o) => {
        return {
          key: o.id,
          value: o.id,
          label: o.title,
          suboperList: o.children || null
        }

      })
      setListOperSearch(dataOperation)
      setListSubSearch([])
      formHolidayDetail.setFieldsValue({ operation: null, sub_operation: null })
    }

    if (type === 'oper') {

      const operationID = e
      if (operationID !== undefined) {
        const dataFindOperationMatch = listopersearch.find((oper) => oper.value === operationID)
        const subOperationList = dataFindOperationMatch.suboperList?.map((sub) => {
          return {
            key: sub.id,
            value: sub.id,
            label: sub.title,
          }
        })
        setListSubSearch(subOperationList)
      } else {
        setListSubSearch([])
      }


      formHolidayDetail.setFieldsValue({ sub_operation: null })


    }
  }
  const onFinishUpload = async (value) => {
    await documentUpload(value)
  }

  const renderComponents = () => {
    if (stateFile === false) {
      return (
        <section className="document-upload-container editwidth">
          <h4>{word['Upload_Document']}</h4>
          {
            state === 'Holiday' &&
            <Form onFinish={onFinishUpload} className="disable-page" style={{ marginTop: 24 }} form={formHolidayDetail} layout="vertical">
              <Form.Item
                label={<h4>Local Holiday Name </h4>}
                name='holiday_name_th'
                rules={[
                  {
                    whitespace: true,
                    required: true,
                    message: 'Local holiday name is require',
                  },
                ]}>
                <Input size="large" />
              </Form.Item>
              <Form.Item
                label={<h4>English Holiday Name</h4>}
                name='holiday_name_en'
                rules={[
                  {
                    whitespace: true,
                    required: true,
                    message: 'English holiday name is require',
                  },
                ]}>
                <Input size="large" />
              </Form.Item>
              <Form.Item
                label={<h4>Business Code</h4>}
                name='company'
                rules={[
                  {
                    required: true,
                    message: 'Company code is require',
                  },
                ]}
              >
                <Select disabled size="large" options={listcompanysearch} onChange={(e) => onChangeEvent(e, 'company')} />
              </Form.Item>
              <Form.Item
                label={<h4>Operation Code</h4>}
                name='operation'
              >
                <Select allowClear size="large" options={listopersearch} onChange={(e) => onChangeEvent(e, 'oper')} />
              </Form.Item>
              <Form.Item
                label={<h4>Project type Code</h4>}
                name='sub_operation'
              >
                <Select allowClear size="large" options={listsubsearch} onChange={(e) => onChangeEvent(e, 'suboper')} />
              </Form.Item>
            </Form>
          }
          <aside className="showfile-container">
            <div>{acceptedFileItems2(files2)}</div>
          </aside>
          <div className="layout-uploadModal">
            <div {...getRootProps({ className: 'dropzone-container' })}>
              <input {...getInputProps()} />
              <img src={icon}></img>
              <h4>{word['Drag_and_drop_here']}</h4>
              <h4>{word['or']}</h4>
              <h4 className="browse">{word['browse']}</h4>
            </div>
            <div className={loading ? 'upload-doc-loading-container' : 'active-waite'}>
              <img src={loadingIcons}></img>
            </div>
          </div>
        </section>
      )
    } else if (stateFile === true) {
      let locale = {
        emptyText: (
          <div className="empty-table-custom" style={{ marginBottom: 32 }}>
            <img className="icon" src={iconSuccess}></img>
            <h2>{word['Validation_Successful']}</h2>
            <div className={loading ? 'upload-doc-loading-container' : 'active-waite'}>
              <img src={loadingIcons}></img>
            </div>
          </div>
        ),
      }

      let locale2 = {
        emptyText: (
          <div className="empty-table-custom-fail" style={{ marginBottom: 32 }}>
            <WarningOutlined className="CloseCircleOutlined" />{' '}
            <h2>{word['Invalid_File']}</h2>
          </div>
        ),
      }

      const datafileReback = dataError.map((item) => {
        let showdataerror = ''
        if (item.error) {
          let dataerror = []
          item.error.map((item) => {
            dataerror.push(item.message)
          })
          let realdataerror = dataerror.join(' , ')
          showdataerror = realdataerror
        } else {
          showdataerror = ''
        }
        return {
          key: item.row_id,
          row: item.row_id,
          message: showdataerror,
        }
      })

      const datafileRebackUser = dataError.map((item) => {
        return {
          key: item.row_id,
          row: item.row_id,
          message: item.message,
        }
      })
      const columnfile = [
        { title: word['Row'], dataIndex: 'row', ellipsis: true, width: 100 },
        {
          title: word['Message'],
          dataIndex: 'message',
          ellipsis: true,
          width: 550,
        },
        {
          ellipsis: true,
          // width: 130,
          render: () => {
            return <CloseCircleOutlined style={{ color: '#ff6258' }} />
          },
        },
      ]

      const ShowIconCheckError = (err) => {
        if (err === true || err == 'nopass') {
          return <CloseCircleOutlined className="CloseCircleOutlined" />
        } else {
          return <CheckCircleOutlined className="color-icon-check" />
        }
      }

      function onChangeTable(pagination2, filters, sorter, extra) {
        if (pagination != false) {
          setPagination((prevState) => {
            return {
              ...prevState,
              pageSize: pagination2.pageSize,
              current: pagination2.current,
            }
          })
        }
      }

      const checkTable = (err) => {
        if (err == true) {
          return (
            <Table
              className="tableImport"
              columns={columnfile}
              locale={locale}
              dataSource={state == 'User' ? datafileRebackUser : datafileReback}
              onChange={onChangeTable}
              pagination={pagination}
            ></Table>
          )
        } else if (err == 'nopass') {
          return <Table columns={columnfile} locale={locale2} dataSource={[]}></Table>
        } else {
          return <Table columns={columnfile} locale={locale} dataSource={[]}></Table>
        }
      }
      return (
        <div className="state-check-file">
          <Row gutter={12} justify="space-between">
            <Col span={12}>
              <div className="box-file">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <img style={{ marginRight: 22 }} src={docxIcon}></img>
                  <div style={{ display: 'grid' }}>
                    <p className="cutter-text-line-1">{files2[0].path}</p>
                  </div>

                  <div style={{ marginLeft: 9 }}>
                    {ShowIconCheckError(checkDataError)}
                  </div>
                </div>
              </div>
            </Col>
            <Col
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
              }}
              span={12}
            >
              <Button
                onClick={() => onClickUploadFile()}
                type="primary"
                className="btn_Secondary2 "
              >
                <PlusOutlined className="Icon-color" />
                {word['Upload_File']}
              </Button>
            </Col>
          </Row>
          {
            state === 'Holiday' && <Row>
              <Form
                className="disable-page"
                onFinish={onFinishUpload}
                style={{ marginTop: 24, width: '100%' }}
                form={formHolidayDetail}
                layout="vertical"
              >
                <Row gutter={24}>
                  <Col span={12}>
                    <Form.Item

                      name='holiday_name_th'
                      label={<h4>Holiday Name</h4>}
                      rules={[
                        {
                          whitespace: true,
                          required: true,
                          message: 'Local holiday name is require',
                        },
                      ]}>
                      <Input disabled size="large" />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      label={<h4>English Holiday Name</h4>}
                      name='holiday_name_en'
                      rules={[
                        {
                          whitespace: true,
                          required: true,
                          message: 'English holiday name is require',
                        },
                      ]}>
                      <Input disabled size="large" />
                    </Form.Item>
                  </Col>
                </Row>

                <Form.Item
                  label={<h4>Business Code</h4>}
                  name='company'
                  rules={[
                    {
                      required: true,
                      message: 'Business code is require',
                    },
                  ]}>
                  <Select disabled size="large" options={listcompanysearch} onChange={(e) => onChangeEvent(e, 'company')} />
                </Form.Item>
                <Row gutter={24}>
                  <Col span={12}>
                    <Form.Item label={<h4>Operation Code</h4>} name='operation' >
                      <Select allowClear disabled size="large" options={listopersearch} onChange={(e) => onChangeEvent(e, 'oper')} />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label={<h4>Project type Code</h4>} name='sub_operation'>
                      <Select allowClear disabled size="large" options={listsubsearch} onChange={(e) => onChangeEvent(e, 'suboper')} />
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Row>
          }

          <Row style={{ marginTop: 22 }}>{checkTable(checkDataError)}</Row>
        </div>
      )
    }
  }

  const onOkUploadFail = () => {
    setVisible(true)
    setVisibleCantDelete(false)
    setCheckClickRetry(true)
  }
  return (
    <div>
      <Modal
        maskClosable={false}
        className="importfile-modal"
        title={titleModal}
        visible={visible}
        onCancel={onCancel}
        okText={wordBtnUpload}
        onOk={() => {
          if (state === 'Holiday') {
            formHolidayDetail.submit()
          } else {
            documentUpload()
          }
        }}
        okButtonProps={{
          id: 'importbutton',
          hidden: displayBtnUpload,
          disabled: files2.length > 0 ? false : true,
        }}
        cancelButtonProps={{ id: 'cancel_import' }}
        destroyOnClose={true}
      >
        {renderComponents()}
        <div className={loading ? 'block-event' : 'active-waite'}></div>
      </Modal>

      <Modal
        maskClosable={false}
        className="ModalStatusOption"
        visible={visibleModalSuccess}
        okText={'OK'}
        onOk={() => setVisibleModalSuccess(false)}
        okButtonProps={{ id: 'filemodalclose' }}
        cancelButtonProps={{ id: 'cancelfile_id', hidden: true }}
        onCancel={() => setVisibleModalSuccess(false)}
      >
        <CheckCircleOutlined className="Icon-style" />
        <h2>{word['btnStatus_title_uploadHoliday']}</h2>
        <h4>
          {word['Your_file_has_been_uploaded_success']}{' '}
          {state == 'User' ? dataSuccess : dataSuccess.length} {word['rows']}
        </h4>
      </Modal>

      <Modal
        maskClosable={false}
        className="DeleteModal edit-size-modal-delete"
        visible={visibleCantDelete}
        onCancel={() => setVisibleCantDelete(false)}
        onOk={() => onOkUploadFail()}
        okText="Retry"
        okButtonProps={{ id: 'ok_holiday' }}
        cancelButtonProps={{ id: 'cancel_holiday' }}
      >
        <CloseCircleOutlined className="CloseCircleOutlined" />
        <h2>{word['btnStatus_title_uploadFailHoliday']}</h2>
        <h4>{word['btnStatus_des_uploadFailHoliday']}</h4>
      </Modal>
    </div>
  )
}

export default Importfile
